import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";

/**
 * Handles the Emergent OAuth callback. When the browser lands on
 * `<origin>/#session_id=<token>`, we exchange it for a session_token
 * via the backend, then redirect the user home.
 */
export default function AuthCallback() {
    const navigate = useNavigate();
    const location = useLocation();
    const { refresh } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        if (processed.current) return;
        processed.current = true;

        const hash = location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        const session_id = match ? decodeURIComponent(match[1]) : null;
        if (!session_id) {
            navigate("/", { replace: true });
            return;
        }

        (async () => {
            try {
                const { data } = await api.post("/auth/session", { session_id });
                await refresh();
                // Clear the hash and land on the appropriate page
                const target = data?.user?.role === "admin" ? "/admin" : "/account";
                navigate(target, { replace: true });
            } catch (e) {
                navigate("/", { replace: true });
            }
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center dawn-wash" data-testid="auth-callback-page">
            <div className="text-center">
                <Loader2 className="w-8 h-8 animate-spin text-[var(--brand-coral)] mx-auto mb-4" />
                <p className="text-slate-600 font-medium">Finalizing sign-in…</p>
            </div>
        </div>
    );
}
